import { Link } from "react-router-dom";

export function LegalFooter({ className = "" }) {
  return (
    <p className={`text-xs text-gray-400 ${className}`} data-testid="legal-footer">
      <Link to="/terms" target="_blank" className="underline hover:text-gray-600" data-testid="terms-link">Terms of Service</Link>
      {" and "}
      <Link to="/privacy" target="_blank" className="underline hover:text-gray-600" data-testid="privacy-link">Privacy Policy</Link>
    </p>
  );
}

export function LegalConsent({ prefix = "By continuing, you agree to our" }) {
  return (
    <p className="text-xs text-gray-400" data-testid="legal-consent">
      {prefix}{" "}
      <Link to="/terms" target="_blank" className="underline hover:text-gray-600">Terms of Service</Link>
      {" and "}
      <Link to="/privacy" target="_blank" className="underline hover:text-gray-600">Privacy Policy</Link>.
    </p>
  );
}
